import { render, staticRenderFns } from "./SelectArea.vue?vue&type=template&id=81bffc50"
import script from "./SelectArea.vue?vue&type=script&lang=js"
export * from "./SelectArea.vue?vue&type=script&lang=js"
import style0 from "./SelectArea.vue?vue&type=style&index=0&id=81bffc50&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports